import type { CmpHider } from './types';

export const ketch: CmpHider = {
  id: 'ketch',
  label: 'Ketch',
  css: `
      /* Ketch (ketch.com, the Lanyard CMP): the entire consent UI — banner,
         purposes/preferences modal (#ketch-modal / #ketch-purposes-modal), and
         the fixed full-viewport dimming backdrop(s)
         (div.ketch-fixed.ketch-z-ketch-max-z-index, bg rgba(49,0,146,0.48),
         z-index 2147483647) — is mounted as children of a single root container,
         #lanyard_root, appended to <body>. The backdrops and modal are all inside
         that root, so hiding #lanyard_root removes the banner and the faded
         background in one go. We also list #ketch-modal / #ketch-purposes-modal
         defensively in case a build mounts the modal outside the root. Ketch locks
         page scroll by setting an inline "position: fixed; top: 0; width: 100%" on
         <body> (it does not change overflow), and that inline style is applied at
         runtime AFTER this style, so the [style*="overflow"] release above does not
         match it — we add a higher-specificity html-led [style*="position: fixed"]
         release to override the inline position lock. */
      #lanyard_root,
      #ketch-modal,
      #ketch-purposes-modal { display: none !important; }
      html[style*="position: fixed"],
      html body[style*="position: fixed"] {
        position: static !important;
        top: auto !important;
        width: auto !important;
        overflow: visible !important;
      }
  `,
};
